// USAGE:
//      CSS:  height: ~"calc(var(--vh, 1vh) * 100)";
//      Javascript:
//      calculateViewportHeight()
//      window.addEventListener('resize', () => {
//          calculateViewportHeight()
//      });

export function calculateViewportHeight() {
	calculateViewportH();
	window.addEventListener('resize', () => {
		calculateViewportH();
	});
}

function calculateViewportH() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}
